var OGENERAL_AR_JW2 = {
  name: "OGENERAL-AR-JW2",
  defaultCommandIndex: 1,
  commands: [
    {
      mode: "AC_MODE_OFF",
      temperature: "AC_TEMP_NULL",
      fan: "AC_FAN_NULL",
      command: [99,0,4,63,13,240,5,238,1,50,1,246,1,100,4,251,1,0,0,169,74,164,170,74,170,170,170,85,85,42,165,85,68],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_AUTO",
      command: [243,0,4,195,1,64,1,211,1,128,4,54,13,241,5,249,1,0,0,59,122,245,255,251,253,250,170,247,253,119,221,255,255,255,255,255,86,209],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_AUTO",
      command: [243,0,4,145,1,155,1,145,1,203,4,207,12,87,6,147,1,0,0,59,122,245,255,251,253,250,170,247,253,119,174,255,255,255,255,255,170,232,128],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_AUTO",
      command: [243,0,4,145,1,154,1,146,1,203,4,208,12,87,6,148,1,0,0,59,122,245,255,251,253,250,170,247,253,119,237,255,255,255,255,255,87,162],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_AUTO",
      command: [243,0,4,145,1,155,1,145,1,203,4,207,12,87,6,146,1,0,0,59,122,245,255,251,253,250,170,247,253,119,182,255,255,255,255,255,170,172,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_AUTO",
      command: [243,0,4,145,1,155,1,145,1,203,4,207,12,87,6,147,1,0,0,59,122,245,255,251,253,250,170,247,253,119,214,255,255,255,255,255,171,88,128],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_AUTO",
      command: [243,0,4,197,1,54,1,212,1,128,4,56,13,239,5,198,1,0,0,59,122,245,255,251,253,250,170,247,253,119,171,127,255,255,255,255,213,108,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_AUTO",
      command: [243,0,4,196,1,54,1,221,1,119,4,55,13,241,5,247,1,0,0,59,122,245,255,251,253,250,170,247,253,119,245,255,255,255,255,255,87,98],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_AUTO",
      command: [243,0,4,199,1,51,1,230,1,110,4,56,13,239,5,249,1,0,0,59,122,245,255,251,253,250,170,247,253,119,186,255,255,255,255,255,85,113],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_AUTO",
      command: [243,0,4,145,1,155,1,145,1,203,4,207,12,87,6,147,1,0,0,59,122,245,255,251,253,250,170,247,253,119,218,255,255,255,255,255,171,113],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_AUTO",
      command: [243,0,4,145,1,155,1,145,1,203,4,207,12,88,6,146,1,0,0,59,122,245,255,251,253,250,170,247,253,119,173,127,255,255,255,255,213,120,128],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_AUTO",
      command: [243,0,4,149,1,102,1,183,1,160,4,2,13,39,6,147,1,0,0,58,245,235,255,239,222,170,189,255,93,250,191,255,255,255,253,95,16],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_AUTO",
      command: [243,0,4,145,1,155,1,145,1,203,4,207,12,87,6,148,1,0,0,59,122,245,255,251,253,250,170,247,253,119,181,127,255,255,255,255,213,85,16],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_AUTO",
      command: [243,0,4,145,1,155,1,145,1,203,4,208,12,88,6,149,1,0,0,59,122,245,255,251,253,250,170,247,253,119,213,127,255,255,255,255,213,170,32],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_LOW",
      command: [243,0,4,145,1,148,1,145,1,201,4,207,12,88,6,147,1,0,0,59,122,245,255,251,253,250,170,247,253,119,221,254,191,255,255,255,235,104,128],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_LOW",
      command: [243,0,4,145,1,155,1,145,1,203,4,208,12,87,6,148,1,0,0,59,122,245,255,251,253,250,170,247,253,119,174,255,95,255,255,255,245,116,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_LOW",
      command: [243,0,4,145,1,155,1,145,1,203,4,206,12,87,6,147,1,0,0,59,122,245,255,251,253,250,170,247,253,119,237,254,191,255,255,255,235,209],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_LOW",
      command: [243,0,4,145,1,125,1,150,1,185,4,208,12,87,6,146,1,0,0,59,107,215,255,239,247,234,171,223,245,222,219,253,127,255,255,255,213,88,128],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_LOW",
      command: [243,0,4,145,1,143,1,145,1,196,4,26,13,15,6,147,1,0,0,59,122,245,255,251,253,250,170,247,253,119,214,255,95,255,255,255,245,172,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_LOW",
      command: [243,0,4,145,1,155,1,146,1,203,4,209,12,88,6,146,1,0,0,59,122,245,255,251,253,250,170,247,253,119,171,127,175,255,255,255,250,182,32],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_LOW",
      command: [243,0,4,145,1,155,1,145,1,203,4,208,12,88,6,147,1,0,0,59,122,245,255,251,253,250,170,247,253,119,245,254,191,255,255,255,235,177],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_LOW",
      command: [243,0,4,145,1,147,1,145,1,203,4,207,12,89,6,145,1,0,0,59,122,245,255,251,253,250,170,247,253,119,186,255,95,255,255,255,245,92,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_LOW",
      command: [243,0,4,145,1,155,1,145,1,204,4,207,12,87,6,146,1,0,0,59,122,245,255,251,253,250,170,247,253,119,218,255,95,255,255,255,245,184,128],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_LOW",
      command: [243,0,4,145,1,155,1,145,1,203,4,208,12,87,6,145,1,0,0,59,122,245,255,251,253,250,170,247,253,119,173,127,175,255,255,255,250,188,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_LOW",
      command: [243,0,4,145,1,155,1,145,1,203,4,208,12,88,6,145,1,0,0,59,122,245,255,251,253,250,170,247,253,119,234,255,95,255,255,255,245,241],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_LOW",
      command: [243,0,4,145,1,147,1,146,1,195,4,207,12,87,6,149,1,0,0,59,122,235,255,247,251,245,85,239,250,239,106,255,95,255,255,255,245,85,16],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_LOW",
      command: [243,0,4,145,1,120,1,152,1,186,4,31,13,9,6,147,1,0,0,59,122,245,255,251,253,250,170,247,253,119,213,127,175,255,255,255,250,213,16],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_MID",
      command: [243,0,4,145,1,131,1,145,1,195,4,209,12,88,6,148,1,0,0,54,245,235,255,247,251,245,85,239,250,239,187,254,255,255,255,255,173,162],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_MID",
      command: [243,0,4,145,1,155,1,146,1,203,4,207,12,89,6,148,1,0,0,59,122,245,255,251,253,250,170,247,253,119,174,255,191,255,255,255,234,232,128],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_MID",
      command: [243,0,4,145,1,155,1,146,1,203,4,209,12,88,6,148,1,0,0,59,122,245,255,251,253,250,170,247,253,119,237,255,127,255,255,255,215,162],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_MID",
      command: [243,0,4,145,1,155,1,145,1,203,4,208,12,87,6,146,1,0,0,59,122,245,255,251,253,250,170,247,253,119,182,255,191,255,255,255,234,172,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_MID",
      command: [243,0,4,145,1,155,1,146,1,203,4,208,12,88,6,147,1,0,0,59,122,245,255,251,253,250,170,247,253,119,214,255,191,255,255,255,235,88,128],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_MID",
      command: [243,0,4,145,1,155,1,146,1,203,4,208,12,89,6,146,1,0,0,59,122,245,255,251,253,250,170,247,253,119,171,127,223,255,255,255,245,108,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_MID",
      command: [243,0,4,145,1,155,1,146,1,203,4,208,12,88,6,146,1,0,0,59,122,245,255,251,253,250,170,247,253,119,245,255,127,255,255,255,215,98],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_MID",
      command: [243,0,4,146,1,155,1,146,1,203,4,208,12,88,6,147,1,0,0,59,122,245,255,251,253,250,170,247,253,119,186,255,191,255,255,255,234,184,128],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_MID",
      command: [243,0,4,145,1,155,1,145,1,203,4,209,12,87,6,146,1,0,0,59,122,245,255,251,253,250,170,247,253,119,218,255,191,255,255,255,235,113],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_MID",
      command: [243,0,4,145,1,155,1,146,1,203,4,209,12,89,6,146,1,0,0,59,122,245,255,251,253,250,170,247,253,119,173,127,223,255,255,255,245,120,128],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_MID",
      command: [243,0,4,145,1,112,1,166,1,173,4,27,13,12,6,145,1,0,0,59,122,245,255,251,253,250,170,247,253,119,234,255,191,255,255,255,235,226],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_MID",
      command: [243,0,4,145,1,141,1,145,1,204,4,29,13,13,6,148,1,0,0,59,122,245,255,251,253,250,170,247,253,119,181,127,223,255,255,255,245,85,16],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_MID",
      command: [243,0,4,145,1,133,1,146,1,196,4,207,12,88,6,147,1,0,0,54,245,215,255,191,223,170,175,127,215,125,87,253,255,255,255,255,90,162],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_HIGH",
      command: [243,0,4,146,1,131,1,147,1,193,4,34,13,13,6,148,1,0,0,54,245,235,255,239,247,234,171,223,245,223,119,251,255,255,255,254,173,162],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_HIGH",
      command: [243,0,4,146,1,155,1,146,1,206,4,213,12,91,6,148,1,0,0,59,122,245,255,251,253,250,170,247,253,119,174,255,127,255,255,255,213,116,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_HIGH",
      command: [243,0,4,146,1,155,1,146,1,203,4,214,12,91,6,148,1,0,0,59,122,245,255,251,253,250,170,247,253,119,237,254,255,255,255,255,171,209],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_HIGH",
      command: [243,0,4,146,1,155,1,146,1,205,4,214,12,90,6,147,1,0,0,59,122,245,255,251,253,250,170,247,253,119,182,255,127,255,255,255,213,86,32],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_HIGH",
      command: [243,0,4,146,1,119,1,156,1,185,4,213,12,91,6,147,1,0,0,59,122,245,255,251,253,250,170,247,253,119,214,255,127,255,255,255,213,172,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_HIGH",
      command: [243,0,4,145,1,156,1,146,1,205,4,213,12,90,6,147,1,0,0,59,122,245,255,251,253,250,170,247,253,119,171,127,191,255,255,255,234,182,32],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_HIGH",
      command: [243,0,4,146,1,155,1,146,1,206,4,213,12,91,6,147,1,0,0,59,122,245,255,251,253,250,170,247,253,119,245,254,255,255,255,255,171,177],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_HIGH",
      command: [243,0,4,145,1,155,1,146,1,205,4,213,12,90,6,147,1,0,0,59,122,245,255,251,253,250,170,247,253,119,186,255,127,255,255,255,213,92,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_HIGH",
      command: [243,0,4,146,1,125,1,160,1,183,4,33,13,13,6,146,1,0,0,54,245,235,255,247,251,245,85,239,250,239,181,254,255,255,255,255,171,113],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_HIGH",
      command: [243,0,4,146,1,155,1,146,1,205,4,214,12,90,6,147,1,0,0,59,122,245,255,251,253,250,170,247,253,119,173,127,191,255,255,255,234,188,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_HIGH",
      command: [243,0,4,145,1,132,1,146,1,197,4,214,12,91,6,146,1,0,0,53,235,215,255,191,126,170,189,255,93,250,191,223,255,255,255,245,124,64],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_HIGH",
      command: [243,0,4,146,1,156,1,146,1,202,4,213,12,90,6,148,1,0,0,59,122,245,255,251,253,250,170,247,253,119,181,127,191,255,255,255,234,170,136],
    },
    {
      mode: "AC_MODE_COOL",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_HIGH",
      command: [243,0,4,146,1,156,1,147,1,206,4,38,13,13,6,149,1,0,0,59,122,245,255,251,253,250,170,247,253,119,213,127,191,255,255,255,234,213,16],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_AUTO",
      command: [243,0,4,146,1,156,1,146,1,205,4,213,12,92,6,149,1,0,0,59,122,245,255,251,253,250,170,247,253,119,223,255,255,255,255,255,214,136],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_AUTO",
      command: [243,0,4,156,1,105,1,189,1,159,4,9,13,40,6,247,1,0,0,59,122,235,255,239,239,213,87,191,235,189,127,255,255,255,255,253,162],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_AUTO",
      command: [243,0,4,196,1,58,1,216,1,131,4,58,13,245,5,251,1,0,0,59,122,245,255,251,253,250,170,247,253,119,239,255,255,255,255,255,221,16],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_AUTO",
      command: [243,0,4,145,1,156,1,146,1,206,4,213,12,90,6,148,1,0,0,59,122,245,255,251,253,250,170,247,253,119,183,255,255,255,255,255,253,16],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_AUTO",
      command: [243,0,4,145,1,156,1,146,1,206,4,215,12,39,6,147,1,0,0,59,122,245,255,251,253,250,170,247,253,119,215,255,255,255,255,255,234,196],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_AUTO",
      command: [243,0,4,145,1,156,1,146,1,205,4,214,12,91,6,147,1,0,0,59,122,245,255,251,253,250,170,247,253,119,171,255,255,255,255,255,250,196],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_AUTO",
      command: [243,0,4,145,1,156,1,146,1,205,4,213,12,90,6,147,1,0,0,59,122,245,255,251,253,250,170,247,253,119,247,255,255,255,255,255,219,16],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_AUTO",
      command: [243,0,4,146,1,156,1,146,1,205,4,215,12,90,6,146,1,0,0,59,122,245,255,251,253,250,170,247,253,119,187,255,255,255,255,255,251,16],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_AUTO",
      command: [243,0,4,146,1,155,1,146,1,205,4,213,12,90,6,147,1,0,0,59,122,245,255,251,253,250,170,247,253,119,219,255,255,255,255,255,235,136],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_AUTO",
      command: [243,0,4,146,1,156,1,146,1,205,4,214,12,90,6,147,1,0,0,59,122,245,255,251,253,250,170,247,253,119,173,255,255,255,255,255,251,136],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_AUTO",
      command: [243,0,4,146,1,156,1,146,1,206,4,214,12,90,6,147,1,0,0,59,122,245,255,251,253,250,170,247,253,119,235,255,255,255,255,255,239,16],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_AUTO",
      command: [243,0,4,146,1,156,1,146,1,205,4,213,12,91,6,147,1,0,0,59,122,245,255,251,253,250,170,247,253,119,181,255,255,255,255,255,255,16],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_AUTO",
      command: [243,0,4,146,1,156,1,146,1,205,4,213,12,89,6,148,1,0,0,59,122,245,255,251,253,250,170,247,253,119,213,255,255,255,255,255,245,81],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_LOW",
      command: [243,0,4,145,1,156,1,146,1,205,4,213,12,90,6,148,1,0,0,59,122,245,255,251,253,250,170,247,253,119,223,253,127,255,255,255,214,209],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_LOW",
      command: [243,0,4,145,1,155,1,146,1,205,4,213,12,90,6,148,1,0,0,59,122,245,255,251,253,250,170,247,253,119,175,254,191,255,255,255,234,232,128],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_LOW",
      command: [243,0,4,146,1,155,1,146,1,205,4,213,12,91,6,148,1,0,0,59,122,245,255,251,253,250,170,247,253,119,239,253,127,255,255,255,215,162],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_LOW",
      command: [243,0,4,146,1,113,1,167,1,173,4,57,13,246,5,147,1,0,0,59,122,245,255,251,253,250,170,247,253,119,183,254,191,255,255,255,234,172,64],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_LOW",
      command: [243,0,4,146,1,155,1,146,1,205,4,213,12,89,6,146,1,0,0,59,122,245,255,251,253,250,170,247,253,119,215,254,191,255,255,255,235,88,128],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_LOW",
      command: [243,0,4,146,1,132,1,146,1,205,4,36,13,10,6,147,1,0,0,59,122,245,255,251,253,250,170,247,253,119,171,255,95,255,255,255,245,108,64],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_LOW",
      command: [243,0,4,145,1,156,1,146,1,205,4,215,12,90,6,148,1,0,0,59,122,245,255,251,253,250,170,247,253,119,247,253,127,255,255,255,215,98],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_LOW",
      command: [243,0,4,146,1,128,1,153,1,187,4,38,13,11,6,147,1,0,0,59,122,245,255,251,253,250,170,247,253,119,187,254,191,255,255,255,234,184,128],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_LOW",
      command: [243,0,4,146,1,156,1,146,1,205,4,38,13,10,6,148,1,0,0,59,122,245,255,251,253,250,170,247,253,119,219,254,191,255,255,255,235,113],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_LOW",
      command: [243,0,4,146,1,155,1,146,1,205,4,213,12,92,6,147,1,0,0,59,122,245,255,251,253,250,170,247,253,119,173,255,95,255,255,255,245,120,128],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_LOW",
      command: [243,0,4,146,1,156,1,146,1,205,4,213,12,90,6,147,1,0,0,59,122,245,255,251,253,250,170,247,253,119,235,254,191,255,255,255,235,226],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_LOW",
      command: [243,0,4,145,1,156,1,146,1,205,4,214,12,90,6,149,1,0,0,59,122,245,255,251,253,250,170,247,253,119,181,255,95,255,255,255,245,85,16],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_LOW",
      command: [243,0,4,176,1,94,1,183,1,163,4,242,12,60,6,211,1,0,0,59,122,245,255,251,253,250,170,247,253,119,213,255,95,255,255,255,245,170,32],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_MID",
      command: [243,0,4,146,1,156,1,146,1,206,4,214,12,91,6,149,1,0,0,59,122,245,255,251,253,250,170,247,253,119,223,254,255,255,255,255,86,209],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_MID",
      command: [243,0,4,146,1,155,1,146,1,206,4,213,12,90,6,148,1,0,0,59,122,245,255,251,253,250,170,247,253,119,175,255,127,255,255,255,170,232,128],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_MID",
      command: [243,0,4,146,1,156,1,147,1,205,4,214,12,89,6,149,1,0,0,59,122,245,255,251,253,250,170,247,253,119,239,254,255,255,255,255,87,162],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_MID",
      command: [243,0,4,145,1,129,1,151,1,187,4,31,13,16,6,146,1,0,0,59,117,215,255,239,247,234,171,223,245,222,223,253,255,255,255,254,170,177],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_MID",
      command: [243,0,4,146,1,156,1,146,1,205,4,213,12,89,6,147,1,0,0,59,122,245,255,251,253,250,170,247,253,119,215,255,127,255,255,255,171,88,128],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_MID",
      command: [243,0,4,145,1,155,1,147,1,205,4,213,12,89,6,147,1,0,0,59,122,245,255,251,253,250,170,247,253,119,171,255,191,255,255,255,213,108,64],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_MID",
      command: [243,0,4,146,1,156,1,146,1,205,4,212,12,91,6,147,1,0,0,59,122,245,255,251,253,250,170,247,253,119,247,254,255,255,255,255,87,98],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_MID",
      command: [243,0,4,146,1,156,1,146,1,206,4,214,12,91,6,147,1,0,0,59,122,245,255,251,253,250,170,247,253,119,187,255,127,255,255,255,170,184,128],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_MID",
      command: [243,0,4,146,1,152,1,146,1,205,4,213,12,91,6,146,1,0,0,59,122,245,255,251,253,250,170,247,253,119,219,255,127,255,255,255,171,113],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_MID",
      command: [243,0,4,209,1,67,1,224,1,117,4,22,13,25,6,235,1,0,0,59,122,245,255,251,253,250,170,247,253,119,173,255,191,255,255,255,213,120,128],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_MID",
      command: [243,0,4,146,1,124,1,161,1,182,4,36,13,10,6,147,1,0,0,59,122,235,255,239,247,234,171,223,245,223,175,253,255,255,255,254,175,136],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_MID",
      command: [243,0,4,146,1,123,1,156,1,185,4,213,12,90,6,149,1,0,0,54,235,175,255,223,223,170,175,127,215,123,95,251,255,255,255,253,85,81],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_MID",
      command: [243,0,4,146,1,155,1,146,1,205,4,213,12,91,6,149,1,0,0,59,122,245,255,251,253,250,170,247,253,119,213,255,191,255,255,255,213,170,32],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_HIGH",
      command: [243,0,4,145,1,155,1,145,1,205,4,213,12,91,6,149,1,0,0,59,122,245,255,251,253,250,170,247,253,119,223,253,255,255,255,255,86,209],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_HIGH",
      command: [243,0,4,146,1,156,1,146,1,205,4,212,12,89,6,148,1,0,0,59,122,245,255,251,253,250,170,247,253,119,175,254,255,255,255,255,170,232,128],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_HIGH",
      command: [243,0,4,145,1,155,1,146,1,205,4,213,12,89,6,149,1,0,0,59,122,245,255,251,253,250,170,247,253,119,239,253,255,255,255,255,87,162],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_HIGH",
      command: [243,0,4,145,1,156,1,146,1,205,4,212,12,90,6,147,1,0,0,59,122,245,255,251,253,250,170,247,253,119,183,254,255,255,255,255,170,172,64],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_HIGH",
      command: [243,0,4,146,1,155,1,146,1,205,4,214,12,91,6,147,1,0,0,59,122,245,255,251,253,250,170,247,253,119,215,254,255,255,255,255,171,88,128],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_HIGH",
      command: [243,0,4,146,1,156,1,146,1,205,4,52,13,92,6,147,1,0,0,59,122,245,255,251,253,250,170,247,253,119,171,255,127,255,255,255,213,108,64],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_HIGH",
      command: [243,0,4,146,1,155,1,146,1,205,4,245,12,90,6,147,1,0,0,59,122,245,255,251,253,250,170,247,253,119,247,253,255,255,255,255,87,98],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_HIGH",
      command: [243,0,4,146,1,155,1,146,1,204,4,212,12,89,6,147,1,0,0,59,122,245,255,251,253,250,170,247,253,119,187,254,255,255,255,255,170,184,128],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_HIGH",
      command: [243,0,4,145,1,156,1,146,1,205,4,212,12,90,6,147,1,0,0,59,122,245,255,251,253,250,170,247,253,119,219,254,255,255,255,255,171,113],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_HIGH",
      command: [243,0,4,145,1,155,1,146,1,205,4,214,12,90,6,148,1,0,0,59,122,245,255,251,253,250,170,247,253,119,173,255,127,255,255,255,213,120,128],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_HIGH",
      command: [243,0,4,145,1,156,1,146,1,201,4,213,12,90,6,147,1,0,0,59,122,245,255,251,253,250,170,247,253,119,235,254,255,255,255,255,171,226],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_HIGH",
      command: [243,0,4,146,1,140,1,147,1,192,4,213,12,90,6,148,1,0,0,59,122,245,255,251,253,250,170,247,253,119,181,255,127,255,255,255,213,85,16],
    },
    {
      mode: "AC_MODE_AUTO",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_HIGH",
      command: [243,0,4,146,1,156,1,146,1,205,4,213,12,92,6,149,1,0,0,59,122,245,255,251,253,250,170,247,253,119,213,255,127,255,255,255,213,170,32],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_18",
      fan: "AC_FAN_AUTO",
      command: [243,0,4,145,1,155,1,146,1,206,4,212,12,89,6,149,1,0,0,59,122,245,255,251,253,250,170,247,253,119,222,255,255,255,255,255,86,209],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_19",
      fan: "AC_FAN_AUTO",
      command: [243,0,4,146,1,155,1,146,1,205,4,212,12,90,6,148,1,0,0,59,122,245,255,251,253,250,170,247,253,119,175,127,255,255,255,255,170,232,128],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_20",
      fan: "AC_FAN_AUTO",
      command: [243,0,4,146,1,155,1,146,1,205,4,212,12,89,6,149,1,0,0,59,122,245,255,251,253,250,170,247,253,119,238,255,255,255,255,255,87,162],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_21",
      fan: "AC_FAN_AUTO",
      command: [243,0,4,146,1,155,1,146,1,205,4,212,12,90,6,147,1,0,0,59,122,245,255,251,253,250,170,247,253,119,183,127,255,255,255,255,170,172,64],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_22",
      fan: "AC_FAN_AUTO",
      command: [243,0,4,146,1,155,1,146,1,205,4,212,12,89,6,147,1,0,0,59,122,245,255,251,253,250,170,247,253,119,215,127,255,255,255,255,171,88,128],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_23",
      fan: "AC_FAN_AUTO",
      command: [243,0,4,145,1,156,1,146,1,205,4,213,12,91,6,147,1,0,0,59,122,245,255,251,253,250,170,247,253,119,171,191,255,255,255,255,213,108,64],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_24",
      fan: "AC_FAN_AUTO",
      command: [243,0,4,146,1,156,1,146,1,205,4,213,12,91,6,147,1,0,0,59,122,245,255,251,253,250,170,247,253,119,246,255,255,255,255,255,87,98],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_25",
      fan: "AC_FAN_AUTO",
      command: [243,0,4,146,1,155,1,146,1,205,4,213,12,89,6,147,1,0,0,59,122,245,255,251,253,250,170,247,253,119,187,127,255,255,255,255,170,184,128],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_26",
      fan: "AC_FAN_AUTO",
      command: [243,0,4,145,1,156,1,146,1,205,4,214,12,91,6,147,1,0,0,59,122,245,255,251,253,250,170,247,253,119,219,127,255,255,255,255,171,113],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_27",
      fan: "AC_FAN_AUTO",
      command: [243,0,4,146,1,156,1,146,1,206,4,214,12,91,6,147,1,0,0,59,122,245,255,251,253,250,170,247,253,119,173,191,255,255,255,255,213,120,128],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_28",
      fan: "AC_FAN_AUTO",
      command: [243,0,4,145,1,155,1,146,1,202,4,213,12,91,6,147,1,0,0,59,122,245,255,251,253,250,170,247,253,119,235,127,255,255,255,255,171,226],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_29",
      fan: "AC_FAN_AUTO",
      command: [243,0,4,146,1,155,1,146,1,205,4,213,12,90,6,149,1,0,0,59,122,245,255,251,253,250,170,247,253,119,181,191,255,255,255,255,213,85,16],
    },
    {
      mode: "AC_MODE_DRY",
      temperature: "AC_TEMP_30",
      fan: "AC_FAN_AUTO",
      command: [243,0,4,145,1,155,1,146,1,205,4,212,12,90,6,149,1,0,0,59,122,245,255,251,253,250,170,247,253,119,213,191,255,255,255,255,213,170,32],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_NULL",
      fan: "AC_FAN_AUTO",
      command: [243,0,4,146,1,128,1,151,1,185,4,212,12,90,6,148,1,0,0,59,122,245,255,251,253,250,170,247,253,119,213,95,255,255,255,255,245,170,32],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_NULL",
      fan: "AC_FAN_LOW",
      command: [243,0,4,145,1,155,1,146,1,205,4,213,12,90,6,149,1,0,0,59,122,245,255,251,253,250,170,247,253,119,213,95,215,255,255,255,251,106,136],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_NULL",
      fan: "AC_FAN_MID",
      command: [243,0,4,198,1,54,1,226,1,109,4,60,13,245,5,201,1,0,0,59,122,245,255,251,253,250,170,247,253,119,213,95,239,255,255,255,246,213,16],
    },
    {
      mode: "AC_MODE_FAN",
      temperature: "AC_TEMP_NULL",
      fan: "AC_FAN_HIGH",
      command: [243,0,4,145,1,156,1,146,1,205,4,213,12,89,6,149,1,0,0,59,122,245,255,251,253,250,170,247,253,119,213,95,223,255,255,255,250,213,16],
    },
  ]
};

export default OGENERAL_AR_JW2
